import type { DecisionLogFormat } from '../../lib/api';

/**
 * File name for a decision-log download, matching the server's
 * Content-Disposition (which a cross-origin client can't read): the case name
 * reduced to letters, digits, spaces, dashes and underscores, then the UTC date.
 */
export function decisionLogFilename(caseName: string, format: DecisionLogFormat, now: Date = new Date()): string {
  const safe = Array.from(caseName)
    .filter((c) => /[\p{L}\p{N} _-]/u.test(c))
    .join('')
    .trim() || 'case';
  return `${safe} decision log ${now.toISOString().slice(0, 10)}.${format}`;
}
